export default __webpack_public_path__ + "static/media/scene_07.839eb62a.mp3";